var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-1 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 分店庫存管理 ")]), _c('div', {
    staticClass: "\n            col-12 col-xl-10\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center justify-content-xl-end\n          "
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-advanced-search",
      modifiers: {
        "collapse-advanced-search": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify mt-1 mr-1"
  }), _vm._v("進階搜尋 ")])], 1), _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('b-collapse', {
    attrs: {
      "id": "collapse-advanced-search"
    },
    model: {
      value: _vm.isAdvancedSearchVisible,
      callback: function callback($$v) {
        _vm.isAdvancedSearchVisible = $$v;
      },
      expression: "isAdvancedSearchVisible"
    }
  }, [_c('b-card', [_c('b-form', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("分店")]), _c('AppSingleSelect', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "id": "branch-select",
      "options": _vm.branchOptions,
      "disabled": _vm.isBranchSelectDisabled
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("類型")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("全部類型")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "type", $$v);
      },
      expression: "query.type"
    }
  }, _vm._l(_vm.productTypes, function (productType) {
    return _c('b-form-select-option', {
      key: productType.value,
      attrs: {
        "value": productType.value
      }
    }, [_vm._v(" " + _vm._s(productType.text) + " ")]);
  }), 1)], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("分類")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.productCategoryOptions
    },
    model: {
      value: _vm.query.category,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "category", $$v);
      },
      expression: "query.category"
    }
  })], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("狀態")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.productStatusOptions
    },
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  })], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("通路")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1)])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetAdvancedSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置條件 ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearchFromAdvanced
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)], 1)], 1), _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('b-card', {
    staticClass: "mb-0"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品名稱或商品序號"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.productSkus,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProductDetail',
              params: {
                product_id: data.item.product.id
              }
            }
          }
        }, [_c('div', {
          staticClass: "mb-1"
        }, [_c('span', {
          attrs: {
            "id": "branch-stock-product-title-".concat(data.item.id)
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString(data.item.product.title === data.item.sku_name ? data.item.product.title : data.item.product.title + " " + data.item.sku_name, 50)) + " ")]), _vm.hasConfigValue(data.item.config) ? _c('b-button', {
          staticClass: "config-link ml-1",
          attrs: {
            "title": "查看 product_skus.config"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.openConfigModal(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-arrow-expand-all"
        })]) : _vm._e()], 1), data.item.product.title || data.item.sku_name ? _c('b-popover', {
          attrs: {
            "target": "branch-stock-product-title-".concat(data.item.id),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(data.item.product.title === data.item.sku_name ? data.item.product.title : data.item.product.title + " " + data.item.sku_name) + " ")])]) : _vm._e(), _c('div', {
          attrs: {
            "id": "branch-stock-sku-code-".concat(data.item.id)
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString("".concat(data.item.sku_code || "", " ").concat(data.item.sku_outer_code || "").trim(), 50)) + " ")]), data.item.sku_code || data.item.sku_outer_code ? _c('b-popover', {
          attrs: {
            "target": "branch-stock-sku-code-".concat(data.item.id),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s("".concat(data.item.sku_code || "", " ").concat(data.item.sku_outer_code || "").trim()))])]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(picture)",
      fn: function fn(data) {
        return [data.item.product.images[0] && data.item.product.images[0].pic_url ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.product.images[0] && data.item.product.images[0].pic_url,
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(max_quantity)",
      fn: function fn(data) {
        return [data.item.isEditing ? _c('div', [_c('b-form-input', {
          staticStyle: {
            "max-width": "125px"
          },
          attrs: {
            "type": "number",
            "min": "0"
          },
          model: {
            value: data.item.max_quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "max_quantity", $$v);
            },
            expression: "data.item.max_quantity"
          }
        })], 1) : _c('div', [_vm._v(" " + _vm._s(data.item.max_quantity) + " ")])];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [data.item.isEditing ? _c('div', [_c('b-form-input', {
          staticStyle: {
            "max-width": "125px"
          },
          attrs: {
            "type": "number",
            "min": "0"
          },
          model: {
            value: data.item.quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "quantity", $$v);
            },
            expression: "data.item.quantity"
          }
        })], 1) : _c('div', [_vm._v(" " + _vm._s(data.item.quantity) + " ")])];
      }
    }, {
      key: "cell(sold_quantity)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.max_quantity - data.item.quantity) + " ")])];
      }
    }, {
      key: "cell(arrange)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BRANCH_PRODUCT_STOCK_MODIFY, _vm.consts.BRANCH_PRODUCT_STOCK_MODIFY_NO_BRANCH]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning"
          },
          on: {
            "click": function click($event) {
              data.item.isEditing ? _vm.updateProductSkuMaxQuantity(data.item, data.item.max_quantity, data.item.quantity) : _vm.toggleEditMode(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v(" " + _vm._s(data.item.isEditing ? "更新" : "編輯") + " ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "branch-product-stock-config-modal",
      "title": _vm.configModalTitle,
      "size": "lg",
      "modal-class": "branch-product-stock-config-modal",
      "hide-footer": ""
    }
  }, [_c('pre', {
    staticClass: "config-preview mb-0"
  }, [_vm._v(_vm._s(_vm.configModalContent))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }